export default "__VITE_ASSET__cacda520__"